import { DataGrid, GridColDef, GridColumnHeaderParams, GridRenderCellParams } from '@mui/x-data-grid';
import React, { useEffect, useRef, useState } from 'react';
import './ManageBucket.css';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { Button, TextField, Tooltip } from "@mui/material";
import { defaultBucketConfig, ManageBucketConfig, manageBucketSearchParams } from './ManageBucketConfig';
import { fetchAllBuckets, updateBucketConfig } from '../../services/manageBucketService';
import { metaDataBatchPayload, popupType } from '../../types/types';
import { bucketActionType } from './ManageBucketTypes';
import { useNavigate } from 'react-router-dom';
import Switch from "react-switch";
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import { Loader } from '../../components/loader/Loader';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { resetBanner } from '../../stateManagement/actions/bannerActions';
import { bucketDesigns } from '../createBucket/bucketTypes';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { META_DATA_BATCH_API } from '../../services/networkService';
import { validateMetaDataResponse } from '../../services/uiConfigService';
import BackButton from '../../components/Buttons/BackButton/BackButton';

const CUR_COMPONENT_COMMON="commonPortal";
const CUR_COMPONENT = "Manage Bucket"

const ManageBucket = (props: { hideBackButton?: boolean }) => {
  const {translate} = usePortalTranslation();
  const [buckets,setBuckets] = useState<any[]>([]);
  const [allBuckets,setAllBuckets] = useState<any[]>([]); //will remove all the any's later
  const allBucketsRef = useRef<any[]>([]);
  const [confirmPopupMessage,setConfirmPopupMessage] = useState<string>("");
  const [bucketConfiguration,setBucketConfiguration] = useState<any>({});
  const [showLoader,setShowLoader] = useState<boolean>(false); 
  const [bucketAction,setBucketAction] = useState<bucketActionType>("changeActiveStatus");
  const [currentBucketData,setCurrentBucketData] = useState<any>({});
  const [openConfirmPopup,setOpenConfirmPopup] = useState<boolean>(false);
  
  const [popupAction,setPopupAction] = useState<popupType>("Alert");
  const [openGenericModal,setOpenGenericModal] = useState<boolean>(false);
  const [genericModalMessage,setGenericModalMessage] = useState<string>("");
  const [searchText,setSearchText] = useState<string>("");


  const defaultFilter = (dataValue: string, searchedValue: string) => {
    if (!dataValue) {
        return;
    }
    dataValue = dataValue.toString();
    return dataValue.toLowerCase().includes(searchedValue.toLowerCase());
  };
  const filterBucketData = (search: string) => {
    if (search) {
        const newData = allBucketsRef.current.filter((bucketObj) => {
            const isPresent = manageBucketSearchParams.filter(
                (searchParam) => {
                    if(searchParam === "bucketDesign"){
                      const bucketDesignId = bucketObj["bucketDesign"];
                      const bucketDesignLabel = bucketDesigns.find((option:{id: string,label: string}) => option.id === bucketDesignId)?.label ?? bucketDesignId;
                      return defaultFilter(bucketDesignLabel, search);
                    }
                    else
                      return defaultFilter(bucketObj[searchParam], search);
                }
            );
            if (isPresent.length !== 0) {
                return true;
            } else {
                return false;
              }
          });
          setBuckets(newData);
      } else {
          setBuckets(allBucketsRef.current);
      }
  };

  async function getAndSetBuckets(){
    try{
      setShowLoader(true);
      let bucketConfig = await fetchAllBuckets();
      if(!bucketConfig){
        bucketConfig = defaultBucketConfig;
      }
      setBuckets(bucketConfig[0].value);
      setAllBuckets(bucketConfig[0].value);
      allBucketsRef.current = bucketConfig[0].value
      setBucketConfiguration(bucketConfig);
      setShowLoader(false);
    }catch(err){
      openPopup("Error","An Error occured while fetching bucket config");
    }
    
  }
  const navigate = useNavigate();
  useEffect(() => {
    getAndSetBuckets();
  },[])
  const columns: GridColDef[] = ManageBucketConfig.columns.map(
    (columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: translate(TranslationEnum.manage_bucket,columnsMetaData.headerName),
        valueGetter: (params) => {
          if(columnsMetaData.mappedValue==="bucketDesignLabel"){
            return bucketDesigns.find((option:{id: string,label: string}) => option.id === params.row.bucketDesign)?.label || "-";
          }else if(columnsMetaData.mappedValue==="primarySource" && params.row.primarySource === "pieceSize"){
            return "Pack Size";
          }else if(columnsMetaData.mappedValue==="primarySource" && params.row.primarySource === "pieceSizeDesc"){
            return "Piece Size Description";
          }
          else
            return params.row[columnsMetaData.mappedValue] || "-";
        },
        sortable: false,
        minWidth: 100,
        flex: 1,
        rowDrag: true,
        headerAlign: "left",
        align: "left",
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={translate(TranslationEnum.manage_bucket,columnsMetaData.headerName)}>
            <b>{translate(TranslationEnum.manage_bucket,columnsMetaData.headerName)}</b>
          </Tooltip>
        ),
      };
    }
  );
 
  async function updateBucket(allBuckets:any[],targetBucket: any,action: bucketActionType,verifiedUser?: manageUpdateAccessObj){
    try{
        const newBucketConfiguration = [...bucketConfiguration];
        const newAllBuckets = action==='changeActiveStatus'? (allBuckets.map((bucket:any) => {
            if(bucket.id === targetBucket.id){
                return {...targetBucket, statusEnabled: !targetBucket.statusEnabled};
            }else{
                return bucket;
            }
        })):(allBuckets.filter((bucket:any) => {
          return bucket.id!==targetBucket.id;
        }));
        newBucketConfiguration[0].value = newAllBuckets;
        const bucketDataPayload = {
            domainName: "clientconfig",
            domainType: "bucket_configuration",
            domainValues: newBucketConfiguration,
            lob: JSON.parse(localStorage.authContext).user.lob,
        }
        const finalMetaDataPayload: metaDataBatchPayload = { features: [bucketDataPayload] };
        validateWithOtp((verifiedUser?: manageUpdateAccessObj,verifyResponse?: any) => {
          if(verifyResponse.status>=200 && verifyResponse.status<300){
            const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
            if(validationObj.success){
              if(action === "changeActiveStatus"){
                setGenericModalMessage(`Bucket with id: ${currentBucketData.id} ${currentBucketData.statusEnabled? "deactivated" : "activated"} successfully`)
              }else{
                setGenericModalMessage(`Bucket with id: ${currentBucketData.id} deleted successfully`);
              }
              setPopupAction("Success");
              getAndSetBuckets();
            }else{
              setGenericModalMessage(validationObj.message);
              setPopupAction("Error");
            }
           
          }else{
            setGenericModalMessage("Something went wrong while updating bucket data");
            setPopupAction("Error");
          }
          setOpenGenericModal(true);
          setSearchText("");
            
        },undefined,"all",META_DATA_BATCH_API,finalMetaDataPayload,"PUT");
    }catch(err){
      console.log(err);
      setPopupAction("Error");
      setGenericModalMessage("Something went wrong!")
      setOpenGenericModal(true);
    }
}

  const addActionAttributes = (
    field: string,
    headerName: "",
    action: (params: GridRenderCellParams) => JSX.Element
  ) => {
    columns.push({
      field,
      headerName,
      sortable: false,
      minWidth: 90,
      flex: 0.5,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      renderCell: action,
    });
  };

  ManageBucketConfig.Actions.forEach((actionName: string) => {
    switch (actionName) {
      case "Update":
        addActionAttributes("Update", "", (params: GridRenderCellParams) => {
          return (
            <button
              className="manage-basket-table-button"
              onClick={async () => {
                if(params.row.bucketDesign==="Need Based Basket Banner"){
                  const currentBucket = params.row;
                  if(!currentBucket.bannerIds && currentBucket.bannerId){
                    currentBucket.bannerIds = [currentBucket.bannerId]
                  }
                    navigate('createBucket',{
                      state: {
                        buckets: allBuckets,
                        currentBucket,
                        bucketConfiguration
                      }
                    })
                }else{
                  resetBanner();
                  navigate('createBucket',{
                    state: {
                      buckets: allBuckets,
                      currentBucket: params.row,
                      bucketConfiguration,
                    }
                  });
                }
                
              }}
            >
              {translate(TranslationEnum.common_portal,"UPDATE")}
            </button>
          );
        });
        break;
      case "Delete":
        addActionAttributes("Delete", "", (params: GridRenderCellParams) => {
          return (
            <button
              className="manage-basket-table-button"
              onClick={() => {
                setConfirmPopupMessage(translate(TranslationEnum.manage_bucket,`Do you want to delete bucket with id: {bucketID}`,{"bucketID":params.row.id}));
                setBucketAction("delete");
                setCurrentBucketData(params.row);
                setOpenConfirmPopup(true);
              }}
            >
              {translate(TranslationEnum.common_portal,"DELETE")}
            </button>
          );
        });
        break;
      case "ChangeStatus":
        addActionAttributes(
          "ChangeStatus",
          "",
          (params: GridRenderCellParams) => {
            return (
              <Switch
              onChange={() => {
                setConfirmPopupMessage(translate(TranslationEnum.manage_bucket,`Do you want to ${params.row.statusEnabled? "deactivate" : "activate"} bucket with id: {bucketID}`,{"bucketID":params.row.id}));
                setBucketAction("changeActiveStatus");
                setCurrentBucketData(params.row);
                setOpenConfirmPopup(true);
              }}
              checked={params.row.statusEnabled === true ? true : false}
              offColor="#909090"
              onColor="#24c6b1"
              size={30}
              handleDiameter={25}
              uncheckedIcon={
                <>
                   <div className="manage-home-screen-toggle-unchecked-icon-status">{translate(TranslationEnum.common_portal,"INACTIVE")}</div>
                </>
              }
              checkedIcon={
                <>
                 <div className="manage-home-screen-toggle-checked-icon-status">{translate(TranslationEnum.common_portal,"ACTIVE")}</div>
                </>
              }
              height={28}
              width={85}
            />
            );
          }
        );
    }
  });
  
  return (
    <div className='manage-bucket-parent'>
        <div className="manage-bucket-header">
            <div className="manage-basket-label">
                <span>{translate(TranslationEnum.manage_bucket,"Manage Bucket")}</span>
            </div>
            <div className="manage-bucket-buttons">
              <TextField
                label={translate(TranslationEnum.common_portal,"Search")}
                name="manageBannerSearch"
                value={searchText}
                size="small"
                onChange= {(event) => {
                  setSearchText(event.target.value);
                  filterBucketData(event.target.value);
                }}
              />
                <Button
                className="manage-bucket-create-new"
                onClick={() => {
                  resetBanner();
                   navigate('createBucket',{
                    state: {
                      buckets: allBuckets,
                      bucketConfiguration
                    }
                  });
                }}
                >
                {translate(TranslationEnum.manage_bucket,"CREATE BUCKET")}
                </Button>
                {!props.hideBackButton && <BackButton/>}
            </div>
        </div>
        <div className='manage-bucket-table'>
            {!showLoader?<DataGrid
                rows={ buckets}
                columns={columns}
                rowSelection={false}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "id", sort: "asc" }],
                  },
                  
                }}
                componentsProps={{
                  pagination: {
                    labelRowsPerPage: translate(TranslationEnum.common_portal,"Rows per page"),
                  },
                }}
            />: <Loader />}
        </div>
        <ConfirmationPopUp 
          openConfirmModal={openConfirmPopup}
          message={confirmPopupMessage}
          setOpenConfirmModal={() => {
            setOpenConfirmPopup(false);
          }}
          successMethod={() => {
           updateBucket(allBucketsRef.current,currentBucketData,bucketAction);
          }}
        />
         <GenericPopUp
          type={popupAction}
          message={genericModalMessage}
          setOpenGenericModal={setOpenGenericModal}
          openGenericModal={openGenericModal}
      />
    </div>
  )
}

export default ManageBucket;